import { render } from "./CvdTestProperties.vue?vue&type=template&id=69426c20"
import script from "./CvdTestProperties.vue?vue&type=script&lang=js"
export * from "./CvdTestProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__